module.exports = __webpack_public_path__ + "media/styles/images/png/move-gray-55da880e7867f58496426e0acc3656e2.png";